// Reine A/V-Sync-Mathematik (SP3b). Konvention: positiver Versatz = TON LIEGT HINTER BILD → wir verzögern
// das BILD um diesen Betrag (videoReceiver.jitterBufferTarget). Browser-Wiring liegt in av-sync-apply.ts.

/** Fallback-Offset pro Rolle, wenn getStats keinen verlässlichen Restversatz liefert (Messung aus SP3a). */
export const DEFAULT_OFFSET_MS = { speaker: 54, guest: 52 } as const;

/** jitterBufferTarget darf nicht negativ werden; sinnvolle Obergrenze gegen Ausreißer. */
export function clampJitterTarget(ms: number, max = 1000): number {
  return Math.max(0, Math.min(max, ms));
}

/**
 * Restversatz in ms aus zwei estimatedPlayoutTimestamps (Sekunden, gleiche Zeitbasis).
 * audioPlayout - videoPlayout: positiv = Audio spielt SPÄTER (hinter Bild) → Bild verzögern.
 * Liefert null, wenn eine der Messungen fehlt (Track ohne Stats).
 */
export function residualFromPlayout(audioPlayoutSec: number | null, videoPlayoutSec: number | null): number | null {
  if (audioPlayoutSec === null || videoPlayoutSec === null) return null;
  return (audioPlayoutSec - videoPlayoutSec) * 1000;
}

/** Neues Video-jitterBufferTarget: aktuellen Wert um den gemessenen Restversatz nachführen, geklemmt. */
export function reZeroTarget(currentTargetMs: number, residualMs: number, max = 1000): number {
  return clampJitterTarget(currentTargetMs + residualMs, max);
}
